// @ts-nocheck
import React, { createRef } from "react";
import TaskInformation from "../../sections/taskInfoSections";
import ProcedureInformation from "../../sections/procedureInfoSections/readOnlyProcedureInfoSection";
import ActiveShareTaskReadOnly from "../../sections/sharedTaskSections/activeShareTaskReadOnly";
import PageHeader from "../../commonComponents/pageHeaders/PageHeader";
import ProcedureDetailService from "../../../service/procedureFile/ProcedureDetailService";
import formateTaskInfoData from "../../sections/taskInfoSections/formateTaskInfoData";
import formateProcedureInfoData from "../../sections/procedureInfoSections/formateProcedureInfoData";
import NormalSpin from "../../../base/basicComponents/spin";
import ProcedureBlock from "../../../base/basicComponents/procedureBlock";
import BaseAlignWithClient from "./alignWithClientSections/baseAlignWithClientSection";
import ReadOnlyAlignWithClient from "./alignWithClientSections/readOnlyAlignWithClientSection";
import ReadOnlyProcedureFileSection from "../../sections/procedureFileSections/readOnlyProcedureFileSection";
import ReadOnlySupportingFileSection from "../../sections/supportingFileSections/readOnlySupportingFileSection";
import ProcessBase from "../../commonComponents/processBase";
import styles from "./styles/index.module.scss";

import StepBusinessType from "../../../service/stepBase/stepBusinessType";
import CompleteStepBusinessType from "../../../service/stepBase/completeStepBusinessType";
import StepService from "../../../service/stepBase/StepService";
import { processDetailRouteMap } from "app/publicDictionaryValues";
import { disableInteraction, enableInteraction } from "utils";

const procedureFileRef = createRef();
const supportingFileRef = createRef();
const procedureFileTableRef = createRef();
const supportingFileTableRef = createRef();
const procedureInfoRef = createRef();

export default class SignOffConfirmation extends ProcessBase {
  constructor(props: any) {
    super(props);
    this.state = {
      loading: false,
      taskInformationData: [],
      isMounted: false,
      ppoList: [],
      procedureInfoData: {},
      alignWithClientValue: null,
      reasonValue: null,
      attachmentFiles: [],
      attachmentFileIds: [],
      attachmentFileNames: [],
      shareTaskData: {},
      status: null,
      reviceDate: null,
      requestBy: null,
      requestByName: null,
      fileLoading: { currentNum: 0, allNum: 0 },
      clientServerPath: "",
      savedInRadioValue: null,
      procedureTableData: [],
      supportingTableData: [],
      jbProcedureSavedIn: null,
      procedureStatusID: null,
      procedureNote: "",
      additionalFiles: [],
      additionalComment: "",
      canUploadAttachment: false,
      processStatus: "",
      triggerProcess: "",
    };
    // @ts-ignore
    this.workflowProcessInstanceId = null;
    // @ts-ignore
    this.flowCategoryID = null;
    // @ts-ignore
    this.signOffStepID = null;
  }

  /* function about adjust null data in api */
  handleDataNull = (file: any, key: any) => {
    if (file[key] === null) {
      if (key === "procedureFileID") {
        return 0;
      } else {
        return null;
      }
    } else {
      return file[key];
    }
  };

  /* callback about get sign off data api success */
  _getSignOffStepSuccess = (result: any) => {
    const fileIds: any[] = [];
    const fileNames: any[] = [];
    result.signOff.attachEmailFiles.forEach((item: any) => {
      fileIds.push(item.fileID);
      fileNames.push(item.attachFileName);
    });

    // @ts-ignore
    this.workflowProcessInstanceId = result.workflowProcessInstanceId;
    // @ts-ignore
    this.flowCategoryID = result.flowCategoryID;
    // @ts-ignore
    this.signOffStepID = result.signOff.signOffStepID;
    this.setState({
      procedureStatusID: result.procedureStatusID,
      status: result.signOff.procedureStepStatus,
      reviceDate: result.reviceDate,
      requestBy: result.requestBy,
      requestByName: result.requestByName,
      isMounted: true,
      alignWithClientValue: result.signOff.alignedWithClientID,
      reasonValue: result.signOff.reason,
      attachmentFiles: result.signOff.attachEmailFiles,
      attachmentFileIds: [...fileIds],
      attachmentFileNames: [...fileNames],
      procedureNote: result.procedureNote,
      additionalFiles: result.signOff.additionalFiles,
      additionalComment: result.signOff.additionalComment,
      canUploadAttachment: result.signOff.canUploadAttachment,
      processStatus: result.signOff.processStatus,
      triggerProcess:
        // @ts-ignore
        processDetailRouteMap[result.signOff.flowCategoryID] +
        result.signOff.procedureTaskID +
        "/" +
        result.signOff.procedureID +
        "/" +
        result.signOff.procedureStepID +
        "/" +
        "ProcessDetail",
    });

    StepService.setStepInterfaceMergePayload(result, {
      isHistorical: result.signOff.procedureStepStatus === "Complete",
      isShareTaskProcess: false,
      // @ts-ignore
      procedureStepId: this.procedureStepID,
      // @ts-ignore
      procedureTaskId: this.taskID,
    });

    this.hideLoading();
  };

  setProcedureInfoData = (result: any) => {
    if (result.procedureStatusID === null || result.procedureStatusID === undefined) {
      result.procedureStatusID = this.state.procedureStatusID;
    }
    result.procedureNote = this.state.procedureNote;

    this.setState({
      procedureInfoData: formateProcedureInfoData.setProcedreInfoData(result),
    });
  };

  setSupportingFileData = (result: any) => {
    if (result.supportingFolder !== null) {
      this.setSupportingTableData(result);
      this.setState({
        // @ts-ignore
        supportingTableData: this.supportingTableData,
      });
    }
  };

  setSavedInServerPathState = (result: any) => {
    this.setState({
      savedInRadioValue: result.procedureFolder?.procedureSaveInCategoryID || null,
      clientServerPath:
        result.procedureFolder !== null ? result.procedureFolder.clientServerPath : "",
    });
  };

  setProcedureFileData = (result: any) => {
    if (result.procedureFolder !== null) {
      this.setProcedureTableData(result.procedureFolder);
      this.setSavedInServerPathState(result);
      this.setState({
        // @ts-ignore
        procedureTableData: this.procedureTableData,
        jbProcedureSavedIn: result.procedureFolder?.jbProcedureSaveIn || null,
      });
    }
  };

  setTaskInfoData = (result: any) => {
    if (result.taskInfomation === null || result.taskInfomation === undefined) {
      return;
    }

    this.setState({
      taskInformationData: formateTaskInfoData.setTaskInfoData(result),
    });
  };

  /* callback about get sign off data api failed */
  _getSignOffStepFailed = (error: any) => {
    this._alertError(error);
  };

  /* callback about get primary procedure owner option list api success */
  _getPrimaryProcedureOwnerDDLSuccess = (result: any) => {
    this.setState({
      ppoList: result,
    });
  };

  /* callback about get primary procedure owner option list api failed */
  _getPrimaryProcedureOwnerDDLFailed = () => {
    this._alertError("Get Primary Procedure Owner Failed");
  };

  /* function about close modal */
  hideModal = () => {
    this.setState({
      isModalOpen: false,
      modalChildContent: "",
      handleModalConfirm: () => {
        //there is a empty function
      },
    });
  };

  /* function about open spin loading */
  openLoading = () => {
    disableInteraction();
    this.setState({ loading: true });
  };

  /* function about close spin loading */
  hideLoading = async () => {
    await enableInteraction();
    this.setState({ loading: false });
  };

  /**
   * Change update attachment loading ui
   * @param {*} fileLoading
   */
  updateFileNumLoading = (fileLoading: any) => {
    this.setState({
      fileLoading: fileLoading,
      loading: fileLoading.allNum !== fileLoading.currentNum,
    });
  };

  /* function about get data through call api */
  componentDidMount() {
    this.openLoading();
    const parentPageData = this._getRoutingParam("ParentPage");
    const para = {
      // @ts-ignore
      TaskID: this.taskID,
      // @ts-ignore
      ProcedureId: this.procedureID,
      // @ts-ignore
      ProcedureStepId: this.procedureStepID,
      parentPage: parentPageData,
    };
    ProcedureDetailService.getSignOffStepItem(para, this._getSignOffStepSuccess, (error: any) => {
      this._getSignOffStepFailed(error);
    });
    // @ts-ignore
    ProcedureDetailService.getPrimaryProcedureOwnerDDL(
      this.taskID,
      this._getPrimaryProcedureOwnerDDLSuccess,
      this._getPrimaryProcedureOwnerDDLFailed
    );
  }

  componentDidUpdate(prevProps: any, prevState: any) {
    if (prevState.procedureInfoData !== this.state.procedureInfoData) {
      const { primaryProcedureOwner, note, procedureOwner } = this.state.procedureInfoData;
      if (procedureInfoRef.current !== null) {
        // @ts-ignore
        procedureInfoRef.current.updatePPO(primaryProcedureOwner);
        // @ts-ignore
        procedureInfoRef.current.updatePO(procedureOwner);
        // @ts-ignore
        procedureInfoRef.current.updateNote(note);
      }
    }
  }

  closePage = () => {
    this.route("/ToDoList");
  };

  render() {
    const {
      loading,
      taskInformationData,
      ppoList,
      procedureInfoData,
      alignWithClientValue,
      reasonValue,
      attachmentFiles,
      attachmentFileIds,
      attachmentFileNames,
      status,
      reviceDate,
      requestByName,
      isMounted,
      clientServerPath,
      savedInRadioValue,
      shareTaskData,
      procedureTableData,
      supportingTableData,
      jbProcedureSavedIn,
      additionalFiles,
      additionalComment,
      canUploadAttachment,
      processStatus,
      triggerProcess,
    } = this.state;

    const params = {
      // @ts-ignore
      ProcedureTaskId: this.taskID,
      // @ts-ignore
      ProcedureID: this.procedureID,
      // @ts-ignore
      ProcedureStepID: this.procedureStepID,
    };

    const getStepParams = {
      // @ts-ignore
      TaskId: this.taskID,
      // @ts-ignore
      ProcedureID: this.procedureID,
      // @ts-ignore
      ProcedureStepID: this.procedureStepID,
    };

    const isCompletePage = status === "Complete";
    const pendingInfoList = [
      StepBusinessType.procedureOwner,
      StepBusinessType.pmpExcluded,
      StepBusinessType.primaryProcedureOwner,
    ];
    const completeInfoList = [
      CompleteStepBusinessType.procedureOwner,
      CompleteStepBusinessType.pmpExcluded,
      CompleteStepBusinessType.primaryProcedureOwner,
    ];

    return (
      <NormalSpin
        spinning={loading}
        size="large"
        indicator={
          this.state.fileLoading.allNum > 0 ? (
            <p className={styles.loadingText}>
              Uploading {this.state.fileLoading.currentNum}/{this.state.fileLoading.allNum} file
            </p>
          ) : undefined
        }
        children={
          <div className={styles.body}>
            <div className={styles.header}>
              {isMounted && (
                <PageHeader
                  title="Upload Sign-off Confirmation"
                  status={status}
                  receiveDate={this._formateDate(reviceDate)}
                  requestBy={requestByName}
                />
              )}
            </div>
            <ProcedureBlock
              child={<TaskInformation data={taskInformationData} />}
              isShowArrow={true}
              isOpen={false}
              testid="task-info-block-arrow"
              onShowDataLoad={() => {
                // @ts-ignore
                return StepService.getStepData(
                  {
                    procedureStepId: getStepParams.ProcedureStepID,
                    procedureTaskId: getStepParams.TaskId,
                    isHistorical: isCompletePage,
                  },
                  this.setTaskInfoData,
                  this.setError,
                  [StepBusinessType.taskInfo]
                );
              }}
            />
            <ProcedureBlock
              className={styles.alignWithClient}
              child={
                isMounted && status === "Complete" ? (
                  <ReadOnlyAlignWithClient
                    loadingProps={{
                      openLoading: this.openLoading,
                      hideLoading: this.hideLoading,
                      updateFileNumLoading: this.updateFileNumLoading,
                    }}
                    status={status}
                    triggerProcess={triggerProcess}
                    alignWithClientValue={alignWithClientValue}
                    reasonValue={reasonValue}
                    attachmentFiles={attachmentFiles}
                    attachmentFileIds={attachmentFileIds}
                    attachmentFileNames={attachmentFileNames}
                    isComplete={true}
                    additionalFiles={additionalFiles}
                    additionalComment={additionalComment}
                    canUploadAttachment={canUploadAttachment}
                    processStatus={processStatus}
                    submitIds={{
                      // @ts-ignore
                      procedureId: this.procedureID,
                      // @ts-ignore
                      workflowProcessInstanceId: this.workflowProcessInstanceId,
                      // @ts-ignore
                      flowCategoryID: this.flowCategoryID,
                      // @ts-ignore
                      procedureStepID: this.procedureStepID,
                      // @ts-ignore
                      signOffStepID: this.signOffStepID,
                      // @ts-ignore
                      procedureTaskID: this.taskID,
                    }}
                  />
                ) : (
                  <BaseAlignWithClient
                    status={status}
                    triggerProcess={triggerProcess}
                    openLoading={this.openLoading}
                    hideLoading={this.hideLoading}
                    alignWithClientValue={alignWithClientValue}
                    reasonValue={reasonValue}
                    attachmentFiles={attachmentFiles}
                    attachmentFileIds={attachmentFileIds}
                    attachmentFileNames={attachmentFileNames}
                    isComplete={false}
                    updateFileNumLoading={this.updateFileNumLoading}
                    closePage={this.closePage}
                    submitIds={{
                      // @ts-ignore
                      procedureId: this.procedureID,
                      // @ts-ignore
                      workflowProcessInstanceId: this.workflowProcessInstanceId,
                      // @ts-ignore
                      flowCategoryID: this.flowCategoryID,
                      // @ts-ignore
                      procedureStepID: this.procedureStepID,
                      // @ts-ignore
                      signOffStepID: this.signOffStepID,
                    }}
                    params={params}
                  />
                )
              }
              isShowArrow={true}
              isOpen={true}
              testid="sign-off-block-arrow"
            />
            <ProcedureBlock
              child={
                <ReadOnlyProcedureFileSection
                  procedureFileData={procedureTableData}
                  procedureFileRef={procedureFileRef}
                  procedureFileTableRef={procedureFileTableRef}
                  clientServerPath={clientServerPath}
                  savedInRadioValue={savedInRadioValue}
                  jbProcedureSavedIn={jbProcedureSavedIn}
                />
              }
              isShowArrow={true}
              isOpen={false}
              testid="procedure-file-block-arrow"
              onShowDataLoad={() => {
                return StepService.getStepData(
                  getStepParams,
                  this.setProcedureFileData,
                  this.setError,
                  [
                    isCompletePage
                      ? CompleteStepBusinessType.procedureFile
                      : StepBusinessType.procedureFile,
                  ],
                  isCompletePage &&
                    StepService.getMergePayloadBySettingKey([
                      CompleteStepBusinessType.procedureFile.settingKey,
                    ])
                );
              }}
            />
            <ProcedureBlock
              child={
                <ReadOnlySupportingFileSection
                  supportingFileRef={supportingFileRef}
                  supportingFileTableRef={supportingFileTableRef}
                  supportingFileData={supportingTableData}
                />
              }
              isShowArrow={true}
              isOpen={false}
              testid="supporting-file-block-arrow"
              onShowDataLoad={() => {
                return StepService.getStepData(
                  getStepParams,
                  this.setSupportingFileData,
                  this.setError,
                  [
                    isCompletePage
                      ? CompleteStepBusinessType.supportingFile
                      : StepBusinessType.supportingFile,
                  ],
                  isCompletePage &&
                    StepService.getMergePayloadBySettingKey([
                      CompleteStepBusinessType.supportingFile.settingKey,
                    ])
                );
              }}
            />
            <ProcedureBlock
              child={
                // @ts-ignore
                <ProcedureInformation
                  ref={procedureInfoRef}
                  isShowActions={false}
                  ppoList={ppoList}
                  submitData={procedureInfoData}
                  noteDisabled={true}
                  isPPODisabled={true}
                  title="Procedure Information"
                />
              }
              isShowArrow={true}
              isOpen={false}
              testid="procedure-info-block-arrow"
              onShowDataLoad={() => {
                return StepService.getStepData(
                  getStepParams,
                  this.setProcedureInfoData,
                  this.setError,
                  isCompletePage ? completeInfoList : pendingInfoList,
                  isCompletePage &&
                    StepService.getMergePayloadBySettingKey([
                      CompleteStepBusinessType.procedureOwner.settingKey,
                      CompleteStepBusinessType.pmpExcluded.settingKey,
                      CompleteStepBusinessType.primaryProcedureOwner.settingKey,
                    ])
                );
              }}
            />
            <ProcedureBlock
              child={<ActiveShareTaskReadOnly title="Shared Task" shareTaskData={shareTaskData} />}
              isShowArrow={true}
              isOpen={false}
              testid="share-task-block-arrow"
              onShowDataLoad={() => {
                // @ts-ignore
                return StepService.getStepData(
                  {
                    ...getStepParams,
                    isHistorical: isCompletePage,
                    isShareTaskProcess: false,
                  },
                  this.setShareTaskData,
                  this.setError,
                  [StepBusinessType.shareTask]
                );
              }}
            />
          </div>
        }
      />
    );
  }
}
